export enum ProductoEstado {
  Borrador,
  VerificadoYActualizado,
  VerificadoYDesactualizado,
  NoVerificado,
  Discontinuado,
  MatrizAveriada,
  MatrizEnReparacion,
  MatrizDiscontinuada,
}

export const ProductoEstadoLabels: { [key in ProductoEstado]: string } = {
  [ProductoEstado.Borrador]: 'Borrador',
  [ProductoEstado.VerificadoYActualizado]: 'Verificado',
  [ProductoEstado.VerificadoYDesactualizado]: 'Verificado',
  [ProductoEstado.NoVerificado]: 'No Verificado',
  [ProductoEstado.Discontinuado]: 'Discontinuado',
  [ProductoEstado.MatrizAveriada]: 'Matriz Averiada',
  [ProductoEstado.MatrizEnReparacion]: 'Matriz en Reparación',
  [ProductoEstado.MatrizDiscontinuada]: 'Matriz Discontinuada',
};

export const getProductoEstado = () => {
  return Object.values(ProductoEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ProductoEstadoLabels[id as ProductoEstado],
    }));
};

export const colorMapping: { [key in ProductoEstado]: string } = {
  [ProductoEstado.Borrador]: '#70BDFF',
  [ProductoEstado.VerificadoYActualizado]: '#22c55e',
  [ProductoEstado.VerificadoYDesactualizado]: 'orange',
  [ProductoEstado.NoVerificado]: 'orange',
  [ProductoEstado.Discontinuado]: 'black',
  [ProductoEstado.MatrizAveriada]: '#FF0000',
  [ProductoEstado.MatrizEnReparacion]: 'orange',
  [ProductoEstado.MatrizDiscontinuada]: 'black',
};
